import {
    Pagination,
    Autocomplete,
    Dialog,
    Input,
    Radio,
    Checkbox,
    Select,
    Option,
    Button,
    Table,
    TableColumn,
    Popover,
    Tooltip,
    Breadcrumb,
    Form,
    FormItem,
    Tabs,
    Alert,
    Icon,
    Row,
    Col,
    Upload,
    Spinner,
    Rate,
    Carousel,
    CarouselItem,
    Cascader,
    Timeline,
    TimelineItem,
    Divider,
    Image,
    Backtop,
    Loading,
    MessageBox,
    Message,
    TabPane,
    Notification,
    InputNumber,
    Badge,
    RadioGroup,
    BreadcrumbItem,
    DatePicker,
    TimeSelect,
    TimePicker,
    Card,
    Calendar,
    // Dropdown,
    // DropdownMenu,
    // DropdownItem,
    Menu,
    Submenu,
    MenuItem,
    // MenuItemGroup,
    // RadioButton,
    // CheckboxButton,
    CheckboxGroup,
    Switch,
    // OptionGroup,
    ButtonGroup,
    Tag,
    // Tree,
    // Slider,
    // Progress,
    // Steps,
    // Step,
    // Collapse,
    // CollapseItem,
    // ColorPicker,
    // Transfer,
    // Container,
    // Header,
    // Aside,
    // Main,
    // Footer,
    Link,
    // PageHeader,
    // CascaderPanel,
    Avatar,
    InfiniteScroll,
    Descriptions,
    DescriptionsItem,
    Drawer,
    Empty
} from 'element-ui'

export default {
    install(V) {
        V.use(Drawer);
        V.use(Empty);
        V.use(Descriptions);
        V.use(DescriptionsItem);
        V.use(Avatar);
        V.use(Pagination);
        V.use(Dialog);
        V.use(Input);
        V.use(Radio);
        V.use(Checkbox);
        V.use(Select);
        V.use(Option);
        V.use(Button);
        V.use(Table);
        V.use(TableColumn);
        V.use(Popover);
        V.use(Tooltip);
        V.use(Breadcrumb);
        V.use(Autocomplete);
        V.use(Form);
        V.use(FormItem);
        V.use(Tabs);
        V.use(Alert);
        V.use(Icon);
        V.use(Row);
        V.use(Upload);
        V.use(Spinner);
        V.use(Rate);
        V.use(Carousel);
        V.use(CarouselItem);
        V.use(Cascader);
        V.use(Timeline);
        V.use(TimelineItem);
        V.use(Divider);
        V.use(Badge);
        V.use(Image);
        V.use(Backtop);
        V.use(Col);
        V.use(TabPane);
        V.use(InputNumber);
        V.use(RadioGroup);
        V.use(BreadcrumbItem);
        V.use(DatePicker);
        V.use(TimeSelect);
        V.use(TimePicker);
        V.use(Card);
        V.use(Calendar);
        // V.use(RadioButton);
        // V.use(CheckboxButton);
        V.use(CheckboxGroup);
        // V.use(OptionGroup);
        // V.use(Dropdown);
        // V.use(DropdownMenu);
        // V.use(DropdownItem);
        V.use(Menu);
        V.use(Submenu);
        V.use(MenuItem);
        // V.use(MenuItemGroup);
        V.use(Switch);
        V.use(ButtonGroup);
        V.use(Tag);
        // V.use(Tree);
        // V.use(Slider);
        // V.use(Progress);
        // V.use(Steps);
        // V.use(Step);
        // V.use(Collapse);
        // V.use(CollapseItem);
        // V.use(ColorPicker);
        // V.use(Transfer);
        // V.use(Container);
        // V.use(Header);
        // V.use(Aside);
        // V.use(Main);
        // V.use(Footer);
        V.use(Link);
        // V.use(PageHeader);
        // V.use(CascaderPanel);
        V.use(InfiniteScroll);

        V.use(Loading.directive);

        V.prototype.$loading = Loading.service;
        V.prototype.$msgbox = MessageBox;
        V.prototype.$alert = MessageBox.alert;
        V.prototype.$confirm = MessageBox.confirm;
        V.prototype.$prompt = MessageBox.prompt;
        V.prototype.$notify = Notification;
        V.prototype.$message = Message;
    }
}


// WEBPACK FOOTER //
// ./src/element/index.js